import { EndPointDoc, Method } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';
import { GenCodeCurl } from '../apiref/genCodeCurl';
import { GenCodeJavaScript } from '../apiref/genCodeJavaScript';
import { GenCodePython } from '../apiref/genCodePython';

export function listModels() : EndPointDoc
{
    const desc = <>
        <p>List all available models, both the base models (Llama-3.1-8b and DeepSeek-R1-8b) and
           all the private models created by the current user.</p>
        </>

    const responseType  = ApiRef.getType("ModelInfo[]");
    const exampleOutput = [
      {
        "beta" : 0.04,
        "default_model" : true,
        "description" : "LLM for advanced reasoning, math, and code tasks.",
        "epsilon" : 0.2,
        "id" : "deppseek-r1-8b",
        "last_modified" : "2025-02-02T12:34:58.488Z",
        "learning_rate" : 1e-05,
        "learning_steps" : 5,
        "name" : "DeepSeek-R1-8b",
        "read_only" : true,
        "revision" : 0,
        "temperature" : 0.7,
        "top_p" : 0.95
      },
      {
        "beta" : 0.04,
        "default_model" : false,
        "description" : "Multilingual large language model from Meta",
        "epsilon" : 0.2,
        "id" : "llama-3.1-8b",
        "last_modified" : "2025-03-14T13:42:48.942Z",
        "learning_rate" : 1e-05,
        "learning_steps" : 5,
        "name" : "Llama-3.1-8b",
        "read_only" : true,
        "revision" : 0,
        "temperature" : 0.7,
        "top_p" : 0.95
      },
      {
        "beta" : 0.8,
        "default_model" : false,
        "description" : "Base on DeepSeek-R1-8b",
        "epsilon" : 0.2,
        "id" : "model42",
        "last_modified" : "2025-11-11T10:13:14.629Z",
        "learning_rate" : 1e-05,
        "learning_steps" : 5,
        "name" : "Model42",
        "parent_model" : "DeepSeek-R1-8b",
        "read_only" : false,
        "revision" : 1,
        "temperature" : 0.7,
        "top_p" : 0.95
      }];

    const exampleUrl     = "v1/models";
    const genCurl        = new GenCodeCurl(Method.Get, exampleUrl);
    const genPython      = new GenCodePython(Method.Get, exampleUrl);
    const genJavaScript  = new GenCodeJavaScript(Method.Get, exampleUrl);
    const codeCurl       = genCurl.generate();
    let codePython       = genPython.generateImport();
    codePython          += genPython.generateRequest();
    codePython          += genPython.readResponse();
    let codeJavaScript   = genJavaScript.generateRequest();
    codeJavaScript      += genJavaScript.readResponse();

    return {
        "title"          : "List Models",
        "method"         : Method.Get,
        "url"            : "v1/models",
        "docurl"         : "list-models",
        "description"    : desc,
        "seoDescription" : "List all available AI models on TigerCity, including base models like Llama-3.1-8b and DeepSeek-R1-8b, plus your custom trained models.",
        "examples" : [
            {
                "url"            : exampleUrl,
                "output"         : exampleOutput,
                "responseType"   : responseType,
                "codeCurl"       : codeCurl,
                "codePython"     : codePython,
                "codeJavaScript" : codeJavaScript
            }
        ]
    };
}

